const META_NAMES = ['csrf-token', 'csrf'] as const;
const INPUT_NAMES = ['csrf_token', 'csrf', '_csrf'] as const;

export const CSRF_HEADER = 'X-CSRF-Token';

export function readCsrfToken(): string {
  for (const name of META_NAMES) {
    const content = document
      .querySelector(`meta[name="${name}"]`)
      ?.getAttribute('content')
      ?.trim();
    if (content) {
      return content;
    }
  }
  for (const name of INPUT_NAMES) {
    const value = document.querySelector<HTMLInputElement>(`input[name="${name}"]`)?.value.trim();
    if (value) {
      return value;
    }
  }
  return '';
}

export function csrfHeaders(init?: HeadersInit): Headers {
  const headers = new Headers(init);
  const token = readCsrfToken();
  if (token !== '' && !headers.has(CSRF_HEADER)) {
    headers.set(CSRF_HEADER, token);
  }
  return headers;
}

let installed = false;

export function installCsrf(): void {
  if (installed) {
    return;
  }
  installed = true;
  document.addEventListener('htmx:configRequest', (event: Event) => {
    const token = readCsrfToken();
    if (token === '') {
      return;
    }
    const detail = (event as CustomEvent<HtmxConfigRequestDetail>).detail;
    if (!detail || typeof detail !== 'object') {
      return;
    }
    if (!detail.headers) {
      detail.headers = {};
    }
    detail.headers[CSRF_HEADER] = token;
    if (detail.parameters && !('csrf_token' in detail.parameters)) {
      detail.parameters.csrf_token = token;
    }
  });
}
